// @ts-nocheck
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { PartModel } from "@store/Framework/Types/ApiModels";
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface Parameter {
    part?: PartModel | undefined;
    tab?: string | undefined;
}

type HandlerType = Handler<Parameter>;

export const DispatchBeginOpenPartFinder: Handler = props => {
    props.dispatch({
        type: "Store/Components/PartFinder/DispatchBeginOpenPartFinder",
    });
};

export const ClosePartFinderDrawer: Handler = props => {
    props.dispatch({
        type: "Store/Components/PartFinder/ClosePartFinderDrawer",
    });
};

export const OpenPartFinderDrawer: Handler = props => {
    props.dispatch({
        type: "Store/Components/PartFinder/OpenPartFinderDrawer",
    });
};

export const DispatchPartFinderDrawer: HandlerType = props => {
    if (props.parameter.part && props.parameter.tab) {
        props.dispatch({
            type: "Store/Components/PartFinder/DispatchPartFinderDrawer",
            part: props.parameter.part,
            tab: props.parameter.tab,
        });
    }
};

export const chain = [
    DispatchBeginOpenPartFinder,
    ClosePartFinderDrawer,
    OpenPartFinderDrawer,
    DispatchPartFinderDrawer,
];

const openPartFinder = createHandlerChainRunnerOptionalParameter(chain, {}, "OpenPartFinderDrawer");
export default openPartFinder;
